
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","width":"66.667","height":"66.667","viewBox":"0 0 920 512"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#cf0209"}},[_c('path',{attrs:{"d":"M431.3 73.1c-7 1.2-15.1 4.3-20.7 8-9.4 6.3-14.9 15-19.1 30.3-1.9 6.8-5.4 10.8-11.1 12.7-2.6.8-15.1 1.4-38.6 1.8-33 .6-34.8.7-37.4 2.7-9.6 7.1-9.2 19.6.9 25.2 3 1.6 12.8 1.7 154.7 1.7 141.9 0 151.7-.1 154.7-1.7 10.1-5.6 10.5-18.1.9-25.2-2.6-2-4.4-2.1-37.4-2.7-47-.8-45.9-.4-52.6-20.3-5.3-15.7-14.3-24.5-31.6-30.9-4.9-1.9-8.1-2.1-31.5-2.3-14.3-.1-28.3.2-31.2.7zM485 99c5.1 1.9 8.8 4.7 12.1 9.3 3.7 5.1 3.8 9 .1 12.6-4 4.1-11.9 5.1-39.2 5.1-27.3 0-35.2-1-39.2-5.1-4.5-4.5-3.4-10.1 3.4-16.6 6.5-6.2 12.6-7.3 39.3-6.9 13.2.2 21.2.8 23.5 1.6zM333.5 174.5c-4.4 1.6-7.1 4.5-7.9 8.8-.4 1.8 4 27.5 10.9 64.6 6.4 33.9 17.2 92 24.1 129.1 14 75.1 13.7 74.1 22.3 78.7l4.4 2.3h78.9c76.3 0 79-.1 82.7-2 4.6-2.3 8.6-6.8 10-11.2.5-1.8 3.2-16.1 6-31.8s12.9-73 22.6-127.5c11-61.8 17.4-100.2 17-102.1-.7-4.3-4.4-8-9.1-9.3-2.7-.8-43.3-1.1-130.9-1.1-106.7.1-127.6.3-131 1.5zm139.7 34.4c1.5 1.7 3.2 4.8 3.8 7 .7 2.7 1 34.6.8 102.3l-.3 98.3-2.2 3.6c-5.2 8.3-15.4 8.4-20.3.2-2-3.4-2-5.2-2-104.4 0-111.5-.4-104.8 6.3-109 4.5-2.8 10.3-2 13.9 2zm-81.7 1.2c1.9 1.7 3.9 4.7 4.5 6.7.6 2.1 8.5 46 17.6 97.7 11.9 67.4 16.4 95.4 16.1 98.9-.4 4.1-1.1 5.5-4.1 8.3-4 3.7-7.9 4.3-12.6 1.8-6.3-3.2-6-2.1-24-104.2-9.4-52.7-17-97.3-17-99.1 0-4.4 2.3-9.6 5.1-11.6 1.3-.9 4.3-1.6 6.6-1.6 3.3 0 5 .7 7.8 3.1zm163.1-1.3c2.8 2.2 5.4 7.4 5.4 10.6 0 1.3-7.7 46-17.1 99.3-15.1 85.6-17.3 97.2-19.5 100.4-6.2 9-17.4 7.5-20.8-2.8l-1.5-4.8 17.2-97.6c15.2-85.9 17.6-98.1 19.7-101.2 1.4-2 3.4-4 4.5-4.6 3.3-1.6 9.8-1.2 12.1.7z"}})])])
          )
        }
      }
    